import styles from '@shared/ui/MainLogo/styles.module.scss';
import { t } from 'i18next';
import logo from '@shared/ui/MainLogo/assets/logo.svg';
import { Link } from 'react-router-dom';
import React from 'react';
import cn from 'classnames';

type Props = {
    className?: string;
};

export const MainLogo: React.FC<Props> = ({ className }) => (
    <Link className={cn(className, styles.logo)} to="/">
        <span className={styles.LogoTitle}>{t('title').toUpperCase()}</span>
        <img src={logo} alt="Go Companion" />
    </Link>
);
